
<div [ngStyle]="{ 'display' : this.airspaceFilterController.active? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
  <div class="loading" [ngClass]="this.airspaceFilterController.loading? 'active' : ''">
    <div></div>
  </div>
  <div class="fields__block">
    <div class="fields__block__section">
      <div class="table-fields">
        <div>
          <div class="btn">
            <button type="submit" (click)="selectAll()" >Select All</button>
            <button type="submit" (click)="deselectAll()" >Deselect All</button>
          </div>
          <div class="scrollable">
            <table>
              <thead>
                <tr>
                  <th></th>
                  <th>Name</th>
                  <th scope="col">Id</th>
                  <th scope="col">On Map</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let proc of airspaceBoundaryController.airspaceBoundaires; let i = index" [class.highlighted]="proc.isselected">
                  <td><input type="checkbox" id="asbCheckbox_{{i}}" name="asbCheckbox_{{i}}" [(ngModel)]="proc.isselected"/></td>
                  <td>{{ proc.name }}</td>
                  <td>{{ proc.uniqueid }}</td>
                  <td>{{ proc.mapstatus }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="btn">
            <button type="submit" (click)="addToMap()">Add To Map</button>
            <button type="submit" (click)="removeFromMap()">Remove From Map</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
